/**
 * Utilitaires pour gérer le localStorage du tutoriel déballage
 */

const TUTORIAL_DELIVERY_KEY = 'lcdf_tutorial_delivery_read';

/**
 * Obtenir l'identifiant unique de l'utilisateur pour le tutoriel déballage
 */
const getUserIdentifier = () => {
  try {
    // Essayer de récupérer l'utilisateur depuis le store User
    const User = require('../services/store/User').default;
    const user = User.getUser();
    
    if (user && user.contact && user.contact.email) {
      return user.contact.email;
    }
    
    if (user && user.id) {
      return `user_${user.id}`;
    }
  } catch (error) {
    // Ignorer les erreurs si le store n'est pas disponible
  }
  
  // Fallback: essayer de récupérer depuis le sessionStorage/localStorage
  const token = sessionStorage.getItem('token');
  const userEmail = sessionStorage.getItem('userEmail') || localStorage.getItem('userEmail');
  const userId = sessionStorage.getItem('userId') || localStorage.getItem('userId');
  
  return userId || userEmail || token || 'anonymous';
};

/**
 * Obtenir la clé de stockage spécifique à l'utilisateur pour le tutoriel déballage
 */
const getStorageKey = () => {
  const userIdentifier = getUserIdentifier();
  return `${TUTORIAL_DELIVERY_KEY}_${btoa(userIdentifier).slice(0, 10)}`;
};

/**
 * Vérifier si l'utilisateur a lu le tutoriel déballage
 */
export const hasReadTutorialDelivery = () => {
  const storageKey = getStorageKey();
  const data = localStorage.getItem(storageKey);
  
  if (data) {
    try {
      const parsedData = JSON.parse(data);
      return parsedData.hasRead === true;
    } catch (error) {
      console.error('Erreur lors de la lecture du statut du tutoriel déballage:', error);
      return false;
    }
  }
  
  return false;
};

/**
 * Marquer le tutoriel déballage comme lu
 */
export const markTutorialDeliveryAsRead = () => {
  const storageKey = getStorageKey();
  const data = {
    hasRead: true,
    readAt: new Date().toISOString(),
    userId: getUserIdentifier(),
    version: '1.0'
  };
  
  localStorage.setItem(storageKey, JSON.stringify(data));
  
  // Déclencher un événement personnalisé pour notifier les autres composants
  window.dispatchEvent(new CustomEvent('tutorialDeliveryRead', {
    detail: { hasRead: true, userId: getUserIdentifier() }
  }));
  
  console.log('Tutoriel déballage marqué comme lu pour l\'utilisateur:', getUserIdentifier());
  
  return true;
};

/**
 * Réinitialiser le statut de lecture du tutoriel déballage (pour debug/admin)
 */
export const resetTutorialDeliveryStatus = () => {
  const storageKey = getStorageKey();
  localStorage.removeItem(storageKey);
  
  console.log('Statut du tutoriel déballage réinitialisé pour l\'utilisateur:', getUserIdentifier());
};